import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SevicesDetail = () => {
    return (
        <div>
            <Link to="/"><Navbar.Brand><img className="img-fluid my-5" src="/McKenzie Logo.png" width="250px" alt="Logo" /></Navbar.Brand></Link>
                <h1>This page under construction</h1>
        </div>
    );
};

export default SevicesDetail;